import { ArticleFragment } from 'api/contentful/contentful.graphql.types'
import { ArticlesSection } from 'components/articlesSection/ArticlesSection'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { toLowerCase } from 'utils/general'

export const DirectiveLPArticleSection: FC<{
  directiveType: 'WILL' | 'TRUST'
  articles: ArticleFragment[]
}> = ({ directiveType, articles }) => {
  const namespace = `${toLowerCase(directiveType)}_lp` as const
  const { t } = useTranslation(namespace, {
    keyPrefix: `${namespace}.section_articles`,
  })
  return (
    <ArticlesSection
      caption={t('caption')}
      title={t('title')}
      description={t('description')}
      articles={articles}
    />
  )
}
